import React, { useState, useEffect, useMemo, MouseEvent } from "react";

import { MenuItem, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FiFilter } from "react-icons/fi";

import { Button } from "../../../../components/Form";
import { Color } from "../../../../components/Form/Button";
import Checkbox from "../../../../components/Form/Checkbox";
import {
  FilterButton,
  FilterHeader,
  IconCountFilter,
  ListContainer,
  MenuFilter,
  TextHeader,
  useStyles,
} from "./styles";
import { FilterCompanyProps, FilterOption } from "Components/SideBar/types";

const FilterCompany: React.FC<FilterCompanyProps> = ({ filterOptions, setFilterOptions }) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [options, setOptions] = useState<FilterOption[]>(() =>
    filterOptions.map((o) => ({ ...o }))
  );

  useEffect(() => {
    setOptions(filterOptions.map((o) => ({ ...o })));
  }, [filterOptions]);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOptions(filterOptions.map((o) => ({ ...o })));
  };

  const handleFilter = () => {
    setFilterOptions(options);
    setAnchorEl(null);
  };

  const checkedCount = useMemo(() => options.filter((o) => o.checked).length, [options]);

  return (
    <Grid item xs={2}>
      <FilterButton
        onClick={handleClick}
        style={{ backgroundColor: anchorEl ? "#03569E" : undefined }}
        data-cy="open-filter-menu"
      >
        <FiFilter size={15} color="#FFFFFF" />
        {checkedCount ? <IconCountFilter>{checkedCount}</IconCountFilter> : null}
      </FilterButton>

      <MenuFilter
        PaperProps={{
          className: classes.menuFilter,
          "data-filter-menu": "true",
        }}
        data-cy="menu-filter-by"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableRestoreFocus
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        onKeyDown={(event) => {
          if (event.key === "Enter") handleFilter();
          if (event.key === "Escape") handleClose();
        }}
      >
        <FilterHeader>
          <TextHeader data-cy="title">{translate("filters")}</TextHeader>
          <Button data-cy="button-save" customColor={Color.SECONDARY} onClick={handleFilter}>
            {translate("go")}
          </Button>
        </FilterHeader>

        <ListContainer data-cy="list-categories" aria-labelledby="nested-list-subheader">
          {options?.length ? (
            options.map((option) => {
              const key = `${option.key}-${option.value}`;
              return (
                <MenuItem key={key}>
                  <Checkbox
                    checked={option.checked}
                    label={option.value}
                    value={option}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setOptions((prev) =>
                        prev.map((opt) =>
                          opt.key === option.key && opt.value === option.value
                            ? { ...opt, checked: e.target.checked }
                            : opt
                        )
                      );
                    }}
                  />
                </MenuItem>
              );
            })
          ) : (
            <MenuItem disabled data-cy="empty-filter-options">
              {translate("noData")}
            </MenuItem>
          )}
        </ListContainer>
      </MenuFilter>
    </Grid>
  );
};

export default FilterCompany;
